(() => {
  const sliderSrc = document.currentScript?.dataset.sliderSrc || '';
  let sliderPromise = null;

  function initHomepageAnchors(root = document) {
    const categorySection = root.querySelector?.('.arl-shop-by-need') || document.querySelector('.arl-shop-by-need');
    if (categorySection && !categorySection.id) categorySection.id = 'shop-by-category';
  }

  function hasMultiSlideHero(root = document) {
    const sliders = [];
    if (root.matches?.('[data-arl-slider]')) sliders.push(root);
    root.querySelectorAll?.('[data-arl-slider]').forEach((slider) => sliders.push(slider));
    return sliders.some((slider) => slider.querySelectorAll('[data-arl-slide]').length > 1);
  }

  function loadSliderModule() {
    if (!sliderSrc) return Promise.resolve();
    if (window.ARLISHCO_HOME_SLIDER_READY) return Promise.resolve();
    if (sliderPromise) return sliderPromise;

    sliderPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-arl-home-slider-module]');
      if (existing) {
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = sliderSrc;
      script.dataset.arlHomeSliderModule = '';
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    }).catch((error) => {
      sliderPromise = null;
      throw error;
    });

    return sliderPromise;
  }

  function init(root = document) {
    initHomepageAnchors(root);
    if (hasMultiSlideHero(root)) loadSliderModule().catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
